import React, { FC } from 'react';
import { useSettings } from '@wix/tpa-settings/react';

import { FieldGroup } from '../../FieldGroup';
import { SectionHeader } from '../../common/SectionHeader';
import { classes } from './SocialLinks.st.css';
import { useFields } from '../../../../../contexts/widget';
import settingsParams from '../../../settingsParams';
import { FieldSection } from '../../../../../types';

export const SocialLinks: FC = () => {
  const fields = useFields();
  const settings = useSettings();

  return (
    <div className={classes.root}>
      <SectionHeader title={settings.get(settingsParams.socialSectionTitle)} />
      <FieldGroup fields={fields} section={FieldSection.SOCIAL} />
    </div>
  );
};
